// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

// import then needed Font Awesome functionality
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faBars, faSearch, faTimes, faArrowRight, faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faTwitter, faLinkedinIn, faWhatsapp } from '@fortawesome/free-brands-svg-icons';

// add the imported icons to the library
library.add(faFacebookF, faTwitter, faBars, faSearch, faTimes, faChevronRight, faChevronLeft, faLinkedinIn, faWhatsapp, faArrowRight);

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();


/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

jQuery(document).ready(function($) {
  if ($(window).width() < 992 && $(window).width() > 576) {
    $('#tly-numbers .carousel-item').each(function(){
      var next = $(this).next();
      if (!next.length) next = $(this).siblings(':first');
      next.children(':first-child').clone().appendTo($(this));
    });
    $('#tly-numbers .carousel-item').each(function(){
      var prev = $(this).prev();
      if (!prev.length) prev = $(this).siblings(':last');
      prev.children(':nth-last-child(2)').clone().prependTo($(this));
    });
  }

  $('.articles-more').on('click', function () {

    $('.article-hidden').slice(0,6).fadeIn('slow', function() {
      $(this).removeClass('article-hidden');

      if( !$('.article-hidden').length ) {
        $('.articles-more').fadeOut('slow');
      }
    });
  })

  $('.rss-more').on('click', function () {
    $('.rss-list .feed-item').css('display', 'block');
    $(this).fadeOut('slow');
  })

  $('.curlang').on('click', function () {
    $('.language-nav').fadeToggle(400);
  })

  $('.rss-list .feed-item').append('<i class="fas fa-arrow-right"></i>');

  $('#main-menu .navbar-nav').append('<li class="mobile-close" data-toggle="collapse" data-target="#main-menu"><i class="fas fa-times"></i></li>');

  $('.navsearch-reset').on('click', function(event) {
    event.preventDefault();
    $('.navbar-search #s').val('').focus();
  });

  $('.search-toggler').on('click', function(event) {
    event.preventDefault();
    $('.navbar-search').toggleClass('is-visible').find('#s').focus();
  });

  $('img.svg').each(function(){
    var $img = $(this);
    var imgID = $img.attr('id');
    var imgClass = $img.attr('class');
    var imgURL = $img.attr('src');

    $.get(imgURL, function(data) {
      // Get the SVG tag, ignore the rest
      var $svg = $(data).find('svg');

      // Add replaced image's ID to the new SVG
      if(typeof imgID !== 'undefined') {
          $svg = $svg.attr('id', imgID);
      }
      // Add replaced image's classes to the new SVG
      if(typeof imgClass !== 'undefined') {
          $svg = $svg.attr('class', imgClass+' replaced-svg');
      }

      // Remove any invalid XML tags as per http://validator.w3.org
      $svg = $svg.removeAttr('xmlns:a');

      // Replace image with new SVG
      $img.replaceWith($svg);
    }, 'xml');

  });
});



// WEBPACK FOOTER //
// ./scripts/main.js